import { useMemo } from 'react';
import { Book } from '@/types/book';

// Hook that uses pre-computed review_count from database
// No additional queries needed - review counts are maintained by database trigger
export function useMostReviewedBooks(allBooks: Book[] | undefined, limit: number = 10) {
  const sortedBooks = useMemo(() => {
    if (!allBooks) return [];
    
    return allBooks
      .filter(book => book.bundle_id != null && (book.review_count || 0) > 0)
      .sort((a, b) => (b.review_count || 0) - (a.review_count || 0))
      .slice(0, limit);
  }, [allBooks, limit]);

  return {
    data: sortedBooks,
    isLoading: !allBooks,
  };
}
